import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { PlanCompleteWorkspace } from '@/components/screens/onboarding/plan-complete-workspace'
import { useMe } from '@/providers/me-context'

export const Route = createFileRoute('/t/$tenant_id/plan/complete')({
  component: Page,
})

function Page() {
  const { tenant_id: tenantId } = Route.useParams()
  const navigate = useNavigate()
  const me = useMe()

  return (
    <PlanCompleteWorkspace
      tenantName={me.tenant.name}
      onStart={() => {
        void navigate({
          to: '/t/$tenant_id',
          params: { tenant_id: tenantId },
        })
      }}
    />
  )
}
